<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">CONTENTS</h1>
<p class="toc-fm"><a href="#/005_Foreword#fm-1"><em>Foreword</em> by Adele Reinhartz</a></p>
<p class="toc-fm"><span href="#/006_Preface#fm-2" title="Link target outside of Sample"><em>Preface</em></span></p>
<p class="toc-part"><span href="#/007_Part01#pt-1" title="Link target outside of Sample">PART 1: THE STORY</span></p>
<p class="toc-sec"><span href="#/007_Part01#sec-1" title="Link target outside of Sample">1 Samuel 28:3–25</span></p>
<p class="toc-sec"><span href="#/007_Part01#sec-2" title="Link target outside of Sample">A Biblical Tale of Thriving in Hard Times</span></p>
<p class="toc-sec"><span href="#/007_Part01#sec-3" title="Link target outside of Sample">The Biblical Story of the Wise Witch of Endor</span></p>
<p class="toc-part"><span href="#/008_Part02#pt-2" title="Link target outside of Sample">PART 2: THE LESSONS</span></p>
<p class="toc-sec1"><span href="#/008_Part02#sec-4" title="Link target outside of Sample">1 <span class="pad">Know Your Power</span></span></p>
<p class="toc-sec1"><span href="#/008_Part02#sec-5" title="Link target outside of Sample">2 <span class="pad">Strive to Excel</span></span></p>
<p class="toc-sec1"><span href="#/008_Part02#sec-6" title="Link target outside of Sample">3 <span class="pad">Choose the Moment</span></span></p>
<p class="toc-sec1"><span href="#/008_Part02#sec-7" title="Link target outside of Sample">4 <span class="pad">Win Well</span></span></p>
<p class="toc-bm"><span href="#/009_Final#bm-1" title="Link target outside of Sample"><em>A Final Word</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Contents.vue?6660429f